<div class="container flex row space-between">
  <div
    class="flex column"
    *ngFor="let priority of vm.allPriorities"
    [ngClass]="{ active: priority.id === vm.selectedPriorityLevelId }"
    [ngStyle]="{
      color: priority.colorHex,
      'border-color':
        priority.id === vm.selectedPriorityLevelId
          ? priority.colorHex
          : '#F5F5F5'
    }"
    (click)="vm.selectPriority(priority)"
  >
    <div>
      <div
        class="dot"
        [ngStyle]="{
          'border-color': priority.colorHex,
          'background-color':
            priority.id === vm.selectedPriorityLevelId
              ? priority.colorHex
              : 'transparent'
        }"
      ></div>
      <b>{{ priority.name }}</b>
    </div>
    <div>{{ priority.creditsLeft }} credits left</div>
    <div></div>
    <div><b>Due At</b></div>
    <div>{{ priority.dueDate }}</div>
  </div>
</div>
